import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { SuperTabsController } from "../../components/ionic2-super-tabs/src";

@Component({
  selector: 'page-unit-info',
  templateUrl: 'unit-info.html'
})
export class UnitInfoPage {

  unit:any;

  constructor(
      public navCtrl: NavController,
      public navParams: NavParams,
      public superTabsCtrl: SuperTabsController
  ) {
    this.unit = navParams.get('unit');
  }

}



// WEBPACK FOOTER //
// ./src/pages/unit-info/unit-info.ts